import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import WorkersByGroupChart from 'components/charts/WorkersByGroupChart';
import MonitorCard from 'components/Dashboard/MonitorCard';

const WorkersByGroupChartCard = ({
  data = [],
  totalWorkers = 0,
  loading = false,
  title = 'Workers By Group',
  cardColor = 'blue',
  cardDate = '',
  showFilterBtn = false,
  currentDate
}) => {
  const formatDate = dateString => {
    return DateTime.fromISO(dateString).toFormat('dd.MM.yyyy');
  };

  const displayDate = cardDate || (currentDate ? formatDate(currentDate) : '');

  return (
    <MonitorCard
      title={title}
      color={cardColor}
      date={displayDate}
      hasData={data.length > 0 && !loading}
      showFilterBtn={showFilterBtn}
    >
      {loading ? (
        <div className="w-full h-96 p-6 flex items-center justify-center">
          <div className="text-gray-500">Loading chart data...</div>
        </div>
      ) : (
        <WorkersByGroupChart data={data} totalWorkers={totalWorkers} />
      )}
    </MonitorCard>
  );
};

export default WorkersByGroupChartCard;

WorkersByGroupChartCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  totalWorkers: PropTypes.number,
  loading: PropTypes.bool,
  title: PropTypes.string,
  cardColor: PropTypes.string,
  cardDate: PropTypes.string,
  showFilterBtn: PropTypes.bool,
  currentDate: PropTypes.string
};
